import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { useSubAccountStore } from "@/store/SubAccountStore";
import request from "project-config/services/request/request";
import { TextButton } from "@/pages/child-customer/atom";

export function StatusButton({
  id,
  status,
  isDingTalkSubAccount,
  deptId,
}: {
  id: number;
  status: number;
  isDingTalkSubAccount?: boolean;
  deptId?: number;
}) {
  const t = getTranslateNsT("center");
  const { fetchSubAccountList, fetchDingTalkSubAccountList, isSearchSubUser } =
    useSubAccountStore();
  async function updateSubUserStatus() {
    const res = await request.post("/api/rendering/user/updateSubUserStatus", {
      id,
      status: Number(!status),
    });
    if (res.result) {
      if (isDingTalkSubAccount) {
        fetchDingTalkSubAccountList({
          deptId: deptId,
          subUserId: isSearchSubUser ? id : undefined,
        });
        return;
      }
      fetchSubAccountList();
    }
  }

  return (
    <TextButton type="text" onClick={updateSubUserStatus}>
      {status ? t("user_button_disable") : t("user_button_able")}
    </TextButton>
  );
}
